import React from 'react'
import DropdownMenu from './DropdownMenu'
import NoCannedReplies from './NoCannedReplies'

class Controller extends React.Component {
  state = {
    focusedCategory: null,
    focusedReply: null,
    mouseX: null,
    mouseY: null,
    categoryStateHeight: null,
  }

  componentDidMount() {
    const { fetchCannedReplyCategories } = this.props
    fetchCannedReplyCategories()
  }

  componentDidUpdate(prevProps) {
    const {
      lastSearchTerm,
      props: {
        isLoadingCategories,
        isLoadingTemplates,
        searchTerm,
        items = [],
      },
    } = this
    // shallow compare seems to get the job done.
    // length not reliable and itemsDifferByKey could get expensive
    const itemsChanged = prevProps.items !== items
    const hasSearchTermChanged = searchTerm !== lastSearchTerm

    if (
      !isLoadingCategories &&
      !isLoadingTemplates &&
      (hasSearchTermChanged || itemsChanged)
    ) {
      this.lastSearchTerm = searchTerm
      if (hasSearchTermChanged) {
        // incase the last action was category toggle collapse, override
        this.preserveFocusOnUpdate = false
      }
      this.focusFirstItem()
    }
  }

  lastSearchTerm = null
  preserveFocusOnUpdate = false

  handleItemSelect = item => {
    const {
      toggleCollapedStateForCategories,
      ticketId,
      selectReply,
      fetchCannedReplies,
      searchTerm,
      isNote,
      isReply,
    } = this.props

    // If someone hits enter on a empty search result
    // or while searching
    if (!item) return null
    if (item.type === 'category') {
      if (!item.loaded && !item.loading)
        fetchCannedReplies([item.id], searchTerm)
      this.preserveFocusOnUpdate = true
      return toggleCollapedStateForCategories([item.id])
    }
    return selectReply(ticketId, item, { isNote, isReply })
  }

  checkMouseMoved = evt => {
    const x = evt.clientX
    const y = evt.clientY
    const mouseMoved = x !== this.state.mouseX && y !== this.state.mouseY
    if (mouseMoved) {
      this.setState({ mouseX: x, mouseY: y })
      return true
    }

    return false
  }

  checkAndFocus = (newState, focusedViaMouse = false, evt) => {
    if (focusedViaMouse) {
      // Dont focus this item if the mouse didnt move (i.e. a scroll event
      // caused the onMouseOver to fire)
      if (!this.checkMouseMoved(evt)) return
    }
    this.setState({ ...newState, focusedViaMouse })
  }

  focusItem = (item, focusedViaMouse = false, evt = null) => {
    const { focusedId } = this.state
    if (item && item.id !== focusedId) {
      this.checkAndFocus({ focusedId: item.id }, focusedViaMouse, evt)
      this.preserveFocusOnUpdate = false
    }
  }

  focusFirstItem = () => {
    const { items = [] } = this.props
    const { focusedId } = this.state

    if (items && items.length > 0) {
      let firstItem
      if (this.preserveFocusOnUpdate && focusedId) {
        // usually when a category is toggled, keep the focus on category
        firstItem = items.find(x => x.id === focusedId)
      } else {
        // Focus on canned template instead of category if template results exist
        // So users can just hit Enter and have the first canned template inserted into editor
        firstItem = items.find(x => x.type === 'template')
      }
      // if above dont exist, get first item
      firstItem = firstItem || items[0]
      this.focusItem(firstItem)
    }
  }

  focusedItem = () => {
    const { items } = this.props
    const { focusedId } = this.state
    const focusedItem = items.find(i => i.id === focusedId)
    return focusedItem
  }

  render() {
    const {
      items,
      isLoadingCategories,
      hasLoadedCategories,
      searchTerm,
      hideModal,
    } = this.props
    const { focusedViaMouse } = this.state

    return (
      <DropdownMenu
        autoScroll={!focusedViaMouse}
        focusedItem={this.focusedItem()}
        focusedItemIcon="keyboard-return"
        isLoadingItems={isLoadingCategories}
        hasLoadedItems={hasLoadedCategories}
        items={items}
        onItemFocus={this.focusItem}
        onItemSelect={this.handleItemSelect}
        emptyPlaceholder={<NoCannedReplies onClick={hideModal} />}
        searchTerm={searchTerm}
      />
    )
  }
}

export default Controller
